import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "../../lib/utils"

type CheckboxVariant = "brand" | "neutral"

const variantClasses: Record<CheckboxVariant, string> = {
  brand: "data-[state=checked]:bg-brand data-[state=checked]:border-brand",
  neutral: "data-[state=checked]:bg-neutral-700 data-[state=checked]:border-neutral-700",
}

type CheckboxProps = React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
  variant?: CheckboxVariant
}

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, variant = "brand", ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "relative h-5 w-5 shrink-0 border-2 border-solid border-neutral-700 rounded-[4px] bg-white appearance-none shadow-none outline-none flex items-center justify-center",
      variantClasses[variant],
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("pointer-events-none absolute inset-0 flex items-center justify-center rounded-[inherit] overflow-hidden")}
    >
      <Check className="h-3 w-3 text-white stroke-[3]" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
